(function() {
	'use strict';

	/**
 	* Repository for the user's wine db.
 	*/

	angular
		.module("pwc.repositories")
		.factory("UserRepository", UserRepository);

	UserRepository.$inject = ['$window'];

	function UserRepository($window){

		/* jshint validthis: true */
		var self = this;

		/**
		 * Begin methods
		 */

		/**
		 * Constructor / Initialization
		 */

		function initialize(){

		}

		// exposed, public API
		return {

		};

	}

})();
